<template>
  <div>
    <b-alert variant="success" :show="showAlert_success" @dismissed="showAlert_success = false">{{ alert_success_message
      }}</b-alert>

    <b-alert variant="danger" :show="showAlert_error" @dismissed="showAlert_error = false">{{ alert_error_message
      }}</b-alert>

    <b-container fluid>
      <h3 class="mt-3 mb-3">Inventory - Cross-Platform Transfer</h3>

      <div class="search_bar mb-3">
        <b-row class="mt-2">
          <b-col cols="12" sm="12" md="3" class="pr-1">
            <b-form-input id="input-small" size="sm" type="text" placeholder="SKU"
              v-model="search_criteria.product_sku"></b-form-input>
          </b-col>
          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
              <font-awesome-icon class="mr-1" icon="search" />Search
            </b-button>
          </b-col>
        </b-row>
      </div>

      <div class="search_bar mb-3">
        <b-row>
          <b-col cols="4" class="pr-1">
            <b-form-file v-model="upload_file" placeholder="Choose a file..." size="sm"></b-form-file>
          </b-col>

          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onUploadFile">Upload</b-button>
          </b-col>
        </b-row>
      </div>

      <b-table id="btable_main" responsive small outlined striped hover sticky-header="500px" :items="items"
        :fields="fields">

        <template v-slot:head(cnt_active)="data">
          <div class="div_cnt">Active</div>
        </template>

        <template v-slot:cell(cnt_active)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_active) }}
          </div>
        </template>

        <template v-slot:cell(action)="data">
          <b-row>
            <b-col cols="3" class="pr-0">
              <b-form-input id="input-small" size="sm" type="text" placeholder="Location"
                v-model="data.item.transfer_location"></b-form-input>
            </b-col>

            <b-col cols="2" class="pl-0 pr-0">
              <b-form-input id="input-small" size="sm" type="text" placeholder="Transfer QTY"
                v-model="data.item.transfer_qty"></b-form-input>
            </b-col>

            <b-col class="pl-0">
              <b-button class="btn-action" size="sm" variant="info" @click="addToTransfer(data.item)">Add to
                Transfer</b-button>
            </b-col>
          </b-row>
        </template>
      </b-table>
      <hr />

      <h4>Transfer To</h4>
      <b-row class="mb-1">
        <b-col cols="2" class="pr-1">
          <strong>Client:</strong>
        </b-col>
        <b-col cols="2" class="pl-0 pr-1">
          <b-form-select size="sm" v-model="transfer_data.to_client_id" :options="client_options" />
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="2" class="pr-1">
          <strong>Transfer Mode (from):</strong>
        </b-col>
        <b-col cols="2" class="pl-0 pr-1">
          <b-form-select size="sm" v-model="transfer_data.transfer_mode_from" :options="transfer_mode_from_options" />
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="2" class="pr-1">
          <strong>Transfer Mode (to):</strong>
        </b-col>
        <b-col cols="2" class="pl-0 pr-1">
          <b-form-select size="sm" v-model="transfer_data.transfer_mode_to" :options="transfer_mode_to_options" />
        </b-col>
      </b-row>
      <br />
      <b-table id="btable_main" responsive small outlined striped hover sticky-header="500px"
        :items="transfer_data.products" :fields="transfer_form_fields">
        <template v-slot:head(cnt_active)="data">
          <div class="div_cnt">Active</div>
        </template>

        <template v-slot:cell(cnt_active)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_active) }}
          </div>
        </template>

        <template v-slot:cell(action)="data">
          <b-button class="btn-action" size="sm" variant="danger" @click="removeTransferProduct(data)">Remove</b-button>
        </template>
      </b-table>

      <b-button class="mt-3 float-right" type="submit" variant="primary" @click="submitForm()">Submit</b-button>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields_show_qty = [
  // {
  //   key: "category",
  //   label: "Primary Category"
  // },
  {
    key: "product_sku",
    label: "Product SKU",
  },
  {
    key: "channel_sku",
    label: "Channel SKU",
    class: "hide",
  },
  {
    key: "other_sku",
    label: "Other SKU",
  },
  {
    key: "vendor",
    label: "Vendor",
  },
  {
    key: "brand",
    label: "Brand",
  },
  {
    key: "product_description",
    label: "Product Description",
  },
  {
    key: "cnt_total",
    label: "Total",
    class: "hide",
  },
  {
    key: "cnt_active",
    label: "Active",
  },
  {
    key: "cnt_committed",
    label: "Committed",
    class: "hide",
  },
  {
    key: "cnt_hold",
    label: "Hold",
    class: "hide",
  },
  {
    key: "cnt_expired",
    label: "Expired",
    class: "hide",
  },
  {
    key: "cnt_damaged",
    label: "Damaged",
    class: "hide",
  },
  {
    key: "cnt_other",
    label: "Other",
    class: "hide",
  },
  {
    key: "expired",
    label: "Expired",
    class: "hide",
  },
  {
    key: "critical_level",
    label: "Critical Level",
    class: "hide",
  },
  {
    key: "action",
    label: "Action",
  },
];

const transfer_form_fields = [
  {
    key: "product_sku",
    label: "Product SKU",
  },
  {
    key: "channel_sku",
    label: "Channel SKU",
    class: "hide",
  },
  {
    key: "other_sku",
    label: "Other SKU",
  },
  {
    key: "vendor",
    label: "Vendor",
  },
  {
    key: "brand",
    label: "Brand",
  },
  {
    key: "product_description",
    label: "Product Description",
  },
  {
    key: "cnt_active",
    label: "Active",
  },
  {
    key: "transfer_location",
    label: "Transfer Location",
  },
  {
    key: "transfer_qty",
    label: "Transfer QTY",
  },
  {
    key: "action",
    label: "Action",
  },
];

import global_function from "../mixins/global_function";
import apiService from "../services/ApiService";

export default {
  name: "InventoryControl",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  mixins: [apiService, global_function],
  components: {
    barcode: VueBarcode,
  },
  data() {
    return {
      transfer_mode_from_options: [
        {
          value: "adjust",
          text: "Adjust",
        },
        {
          value: "Stock-out",
          text: "Stock-out",
        },
      ],
      transfer_mode_to_options: [
        {
          value: "adjust",
          text: "Adjust",
        },
        {
          value: "Stock-in",
          text: "Stock-in",
        },
      ],
      transfer_data: {
        to_client_id: null,
        products: [],
        transfer_mode_from: 'adjust',
        transfer_mode_to: 'adjust'
      },
      transfer_form_fields: transfer_form_fields,
      crit_lv_yellow_from: 100,
      crit_lv_yellow_to: 200,
      col_filter: {
        cnt_total: true,
        cnt_active: false,
        cnt_damaged: false,
        cnt_hold: false,
        cnt_expired: false,
        cnt_committed: false,
        cnt_other: false,
      },
      courier_options: [],
      export_date: {
        start_at: moment().subtract(7, "d").format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD"),
      },
      upload_file: [],
      loader_full: false,
      loader: false,
      items: [],
      showQty: false,
      fields: fields_show_qty,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        status_selected: null,
      },
      search_criteria: {
        product_sku: null,
        status_selected: null,
      },
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      status_options: [
        {
          value: null,
          text: "All Status",
        },
        {
          value: "Expired",
          text: "Expired",
        },
        {
          value: "Critical Level",
          text: "Critical Level",
        },
      ],

      client_options: [],
    };
  },
  async created() {
    // this.fields[1].class = 'hide';

    let clients_response = await this.getClients(this.$store.state.user_obj);

    // hardcode for some
    let valid_client = [
      "Asia_Miles",
      "AsiaMiles_O2O",
      "HKJC",
      "GolsPlatform",
      "CLP",
      "GOLSSTOCK",
      "LNA",
      "RMI",
      "NKL",
      "NKL",
      'NoHyp',
      'ATL',
      '3CFF'

    ];
    for (let i in clients_response.clients) {
      if (valid_client.indexOf(clients_response.clients[i].client_name) != -1) {
        this.client_options.push({
          value: clients_response.clients[i].id,
          text: clients_response.clients[i].full_name,
        });
      }
    }

    this.initialized = true;
  },
  mounted() {
    // this.loader = this.$loading.show({
    //   isFullPage: true,
    //   canCancel: false
    // });
  },
  methods: {

    number_formatter: (value) => {
      if (!value) {
        return "-";
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getInventoryControl() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      if (this.$store.state.user_obj.client_id == "29") {
        this.crit_lv_yellow_from = 1;
        this.crit_lv_yellow_to = 3;
      }
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inventory_cp_lookup.php",
        data: {
          offset: this.table_offset,
          limit: 2000,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      this.items = response.data.products;

      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    async onUploadFile() {
      if (!this.upload_file) {
        this.showAlert_error = true;
        this.alert_error_message = "Please select a file to upload.";
        return;
      }

      const formData = new FormData();
      formData.append("file", this.upload_file);
      formData.append("user_id", this.$store.state.user_obj.user_id);
      formData.append("client_id", this.$store.state.user_obj.client_id);

      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      try {
        let response = await this.$http.post(`${this.API_HOST}/inventory_cp_lookup.php`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data.status === "success") {
          this.items = response.data.products;
          this.showAlert_success = true;
          this.alert_success_message = "File uploaded successfully.";
        } else {
          this.showAlert_error = true;
          this.alert_error_message = response.data.message;
        }
      } catch (error) {
        this.showAlert_error = true;
        this.alert_error_message = "An error occurred while uploading the file.";
      } finally {
        this.loader.hide();
      }
    },

    onSearch() {
      if (this.search_criteria.product_sku == null || this.search_criteria.product_sku == '') {
        return;
      }
      this.getInventoryControl();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * 2000;
      this.getInventoryControl();
    },

    addToTransfer(product_data) {
      console.log(product_data);
      let is_valid = true;
      let error_msg = false;
      if (!product_data.cnt_active) {
        is_valid = false;
        error_msg = "No Active QTY";
      } else if (isNaN(product_data.transfer_qty)) {
        is_valid = false;
        error_msg = "Invalid Transfer QTY";
      } else if (product_data.transfer_qty <= 0) {
        is_valid = false;
        error_msg = "Transfer QTY must be > 0";
      } else if (product_data.transfer_qty > product_data.cnt_active) {
        is_valid = false;
        error_msg = "Transfer QTY must be < Active QTY";
      } else if (product_data.transfer_location == '' || product_data.transfer_location == null) {
        is_valid = false;
        error_msg = "Invalid Transfer Location";
      }

      if (!is_valid) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: error_msg,
        });
        return;
      }
      this.transfer_data.products.push(
        JSON.parse(JSON.stringify(product_data))
      );

      product_data.transfer_qty = null;
      product_data.transfer_location = null;
    },

    removeTransferProduct(data) {
      console.log(data);
      this.transfer_data.products.splice(data.index, 1);
    },

    async submitForm() {
      let is_valid = true;
      let error_msg = false;
      if (this.transfer_data.products.length == 0) {
        is_valid = false;
        error_msg = "No product to transfer";
      }

      if (this.transfer_data.to_client_id == null) {
        is_valid = false;
        error_msg = "Please select client to transfer";
      }

      if (!is_valid) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: error_msg,
        });
        return;
      }

      console.log(this.transfer_data);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inventory_cp_transfer.php",
        data: {
          to_client_id: this.transfer_data.to_client_id,
          transfer_mode_from: this.transfer_data.transfer_mode_from,
          transfer_mode_to: this.transfer_data.transfer_mode_to,
          transfer_products: this.transfer_data.products,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      if (response) {
        if (response.data.status == "success") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Transfer Success",
          });

          this.search_criteria.product_sku = null;

          this.items = [];

          this.transfer_data = {
            to_client_id: null,
            products: [],
          };
        } else {
          this.$eventHub.$emit("show_modal_message", {
            message_content: response.data.message,
          });
        }
      }
    },
  },
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.div_cnt {
  text-align: center;
}

.hide {
  display: none;
}

.toggle_qty {
  font-size: 12px;
  border: 1px solid #eaeaea;
  padding: 2px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/InventoryCrossPlatformTransfer.vue